import { useQuery } from "@tanstack/react-query";
import { useDataProvider, useGetIdentity } from "ra-core";
import type { CrmDataProvider } from "@/components/atomic-crm/providers/types";
import { useOrgModules } from "@/modules/useOrgModules";

export const useMessagingEnabled = () => {
  const dataProvider = useDataProvider<CrmDataProvider>();
  const { identity, isPending: identityPending } = useGetIdentity();
  // SMS and calls belong to the Messages app (Apps); off means off everywhere.
  const moduleOn = useOrgModules().isEnabled("messages");
  const { data, isPending } = useQuery({
    queryKey: ["messaging-settings"],
    queryFn: () => dataProvider.getMessagingSettings(),
    enabled: !!identity?.id && moduleOn,
    staleTime: 30_000,
    retry: false,
    refetchOnWindowFocus: true,
  });

  return {
    smsEnabled: moduleOn && data?.sms_enabled === true,
    voiceEnabled: moduleOn && data?.voice_enabled === true,
    messagingProvider:
      data?.messaging_provider === "telnyx" ? "telnyx" : "twilio",
    // Avoid unregistering the softphone when refetching settings on tab focus.
    isPending: identityPending || (moduleOn && isPending && !data),
  };
};
